import { Typography } from "@mui/material";
import AdminLayout from "Layout/Admin";

function AdminReports() {
    return (<AdminLayout>
        <Typography>Admin Reports</Typography>
    </AdminLayout>);
}

export default AdminReports;